import BaseCheckbox from '@components/BaseCheckbox';
import { Box, FormControlLabel, Stack, Typography } from '@mui/material';
import { CameraSubTasks, SubTaskStatus } from '@pages/task-management/config';
import color from '@theme/Colors';
import moment from 'moment';
import { formatUKDateTime } from 'src/helpers';

interface SubTaskTooltipContentProps {
    subTasks: CameraSubTasks[];
    onToggleSubTask: (index: number, currentStatus: SubTaskStatus) => void;
}

export default function SubTaskTooltipContent({ subTasks, onToggleSubTask }: SubTaskTooltipContentProps) {
    return (
        <Box sx={{ py: 0.5 }}>
            {subTasks.map((subTask, index) => {
                const isDone = subTask.Status === SubTaskStatus.Done;
                const formattedDate = subTask.CompletedAt ? formatUKDateTime(subTask.CompletedAt) : '';

                return (
                    <Stack
                        key={index}
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                            py: 0.5,
                            opacity: isDone ? 1 : 0.8,
                            '&:hover': {
                                opacity: 1,
                            },
                        }}
                    >
                        <FormControlLabel
                            control={
                                <BaseCheckbox
                                    checked={isDone}
                                    onChange={() => onToggleSubTask(index, subTask.Status)}
                                />
                            }
                            label={
                                <Typography
                                    component="span"
                                    color={color.textSecondary}
                                    sx={{
                                        ml: 1,
                                    }}
                                >
                                    {subTask.Name} ({subTask.Status}){isDone && formattedDate && ` - ${formattedDate}`}
                                </Typography>
                            }
                        />
                    </Stack>
                );
            })}
        </Box>
    );
}
